import { Transforms, Editor } from "slate";

import { TagElement } from "components/slate/plugins/tag/types";

export const insertTagElement = (editor: Editor, element: TagElement) => {
  Transforms.insertNodes(editor, element);
  Transforms.insertText(editor, " ");
  Transforms.move(editor, { unit: "character" });
};
